var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src && _vm.isValid)?_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.src},on:{"error":function($event){_vm.isValid = false}}}):_c('v-icon',[_vm._v(" "+_vm._s(_vm.errorIcon || _vm.$icons.mdiFileDocumentOutline)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }